<template>
  <Tooltip :text="t('tooltip')" :hide-delay="200">
    <button
      type="button"
      class="btn btn-sm nav-btn-icon"
      :aria-label="t('tooltip')"
      @click="onClickAdd"
    >
      <span class="icon-wrapper">
        <i class="bi bi-envelope-fill" aria-hidden="true" />
        <span
          v-if="localHasUnread"
          class="badge-count"
        >
          {{ unreadCountLabel }}
        </span>
      </span>
    </button>
  </Tooltip>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useIntervalFn } from '@vueuse/core'
import { useApi } from 'soykajs/composables/api'
import { useModalStack } from '@/stores/modalstack'
import config from '@/config'
import Tooltip from '@/components/tooltip.vue'
import Messages from '@/views/messages/list.vue'

const { t } = useI18n()
const interval = Number(config.VITE_STATUS_INTERVAL ?? 30000)
const { model: unreadStatus, refresh: rawRefresh } = useApi({
  url: 'notifications/has_unread',
  data: { has_unread: false, unread_count: 0 },
})
const localHasUnread = ref(false)
const unreadCount = ref(0)
const unreadCountLabel = computed(() => (unreadCount.value > 99 ? '99+' : String(unreadCount.value)))

const refresh = async () => {
  try {
    await rawRefresh()
    unreadCount.value = Number(unreadStatus.value?.unread_count || 0)
    localHasUnread.value = !!unreadStatus.value?.has_unread
  } catch {
    // Фоновый опрос: сбой API не должен давать Uncaught (in promise).
  }
}
if (interval > 0) {
  useIntervalFn(refresh, interval, { immediate: true, immediateCallback: true })
}
const { push: openModal } = useModalStack()

function onClickAdd() {
  openModal({
    component: Messages,
    props: {
      class: 'modal-messages',
      headerText: t('modalTitle'),
      localHasUnread,
    },
  })
}
</script>
<style scoped>
.icon-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  width: 1em;
  height: 1em;
}

/* Не .bi / .badge Bootstrap — иначе navbar раздувает индикатор */
.badge-count {
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(45%, -45%);
  min-width: 14px;
  height: 14px;
  padding: 0 3px;
  border-radius: 999px;
  background: #ff453a;
  color: #fff;
  font-size: 0.55rem;
  font-weight: 700;
  line-height: 14px;
  text-align: center;
  box-shadow: 0 0 0 1.5px rgba(0, 31, 99, 0.9);
  z-index: 2;
  pointer-events: none;
}
</style>

<i18n>
{
  "ru": {
    "modalTitle": "Список сообщений",
    "tooltip": "Внутренние нотификации"
  },
  "en": {
    "modalTitle": "Message list",
    "tooltip": "Internal notifications"
  }
}
</i18n>
